var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-right" },
    [
      _c(
        "b-button",
        {
          staticClass: "btn-icon rounded-circle mt-1",
          attrs: { size: "sm", id: "popover-sign", variant: "flat-primary" }
        },
        [_c("feather-icon", { attrs: { icon: "InfoIcon" } })],
        1
      ),
      _c(
        "b-popover",
        {
          attrs: {
            target: "popover-sign",
            triggers: "focus",
            placement: "top"
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [_c("span", [_vm._v("Definir ubicación de firmas!")])]
              },
              proxy: true
            }
          ])
        },
        [
          _c("span", [
            _vm._v(
              " Podrás predefinir la ubicación de las firmas de los usuarios que formen parte del flujo como firmantes, ellos al momento de hacer la gestión desde su bandeja de entrada ya vendrá posicionada la firma donde tú la ubiques. "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }